import { useUserConfig } from '@/lib/hooks/context'

export const useHideBanner = () => {
  const config = useUserConfig()

  return config.hideBanner
}
